export default __webpack_public_path__ + "static/media/calculation-workflow-logo.57d9a5ce.svg";